import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

export const Loader = styled.div`
  display: inline-block;
  position: relative;
  z-index: 1;
  &.start {
    .left {
      position: absolute;
      clip: rect(
        0,
        ${calculateResponsiveSize(24)},
        ${calculateResponsiveSize(24)},
        ${calculateResponsiveSize(12)}
      );
    }

    .right {
      position: absolute;
      clip: rect(
        0px,
        ${calculateResponsiveSize(12)},
        ${calculateResponsiveSize(24)},
        0px
      );
    }

    span {
      width: ${calculateResponsiveSize(24)};
      height: ${calculateResponsiveSize(24)};
      border-radius: 100%;
      position: absolute;
      border: 1px solid #fff;
    }
    .left span {
      clip: rect(
        0px,
        ${calculateResponsiveSize(12)},
        ${calculateResponsiveSize(24)},
        0px
      );
      -webkit-animation: rotate-left 5s infinite linear;
    }

    .right span {
      clip: rect(
        0,
        ${calculateResponsiveSize(24)},
        ${calculateResponsiveSize(24)},
        ${calculateResponsiveSize(12)}
      );
      -webkit-animation: rotate-right 5s infinite linear;
    }
  }

  @-webkit-keyframes rotate-left {
    0% {
      -webkit-transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    100% {
      -webkit-transform: rotate(180deg);
    }
  }

  @-webkit-keyframes rotate-right {
    0% {
      -webkit-transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(180deg);
    }
  }
  ${mediaMax('mobile')} {
    &.start {
      .left {
        clip: rect(
          0,
          ${calculateMobileResponsiveSize(24)},
          ${calculateMobileResponsiveSize(24)},
          ${calculateMobileResponsiveSize(12)}
        );
      }

      .right {
        clip: rect(
          0px,
          ${calculateMobileResponsiveSize(12)},
          ${calculateMobileResponsiveSize(24)},
          0px
        );
      }
      span {
        width: ${calculateMobileResponsiveSize(24)};
        height: ${calculateMobileResponsiveSize(24)};
      }
      .left span {
        clip: rect(
          0px,
          ${calculateMobileResponsiveSize(12)},
          ${calculateMobileResponsiveSize(24)},
          0px
        );
      }

      .right span {
        clip: rect(
          0,
          ${calculateMobileResponsiveSize(24)},
          ${calculateMobileResponsiveSize(24)},
          ${calculateMobileResponsiveSize(12)}
        );
      }
    }
  }
`
